import React from 'react';
import { Container } from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';
import PageNotFound from './PageNotFound';
import ContentFrame from '../components/ContentFrame';

import Data from '../data/LabsData';

const Lab = (props) => {
  const { labId } = useParams();
  const selectedLab = Data[labId];
  const { pathname } = useLocation();
  const section = pathname.replace(/\/$/, "").split("/")[3];

  if (!selectedLab || (section && !selectedLab.content[section])) return <PageNotFound />;

  return (
    <>
      <Container maxWidth='lg' sx={{ py: { xs: 2, md: 4 } }}>
        <ContentFrame
          data={selectedLab}
          labName={selectedLab.name}
          description={selectedLab.description}
          menuItems={selectedLab.sections}
        />
      </Container>
    </>
  );
};

export default Lab;
